import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Button, Form, Input, Layout, Spin, Typography } from "antd";
import "~assets/css/common.css";
import { connectPost } from "~utils/api-utils";
import {API_CONST, URL} from "~utils/constants/api-const";
import { getTimeLoadDom } from "~utils";
import { navigate } from "gatsby";
import Cookies from "js-cookie";
import { MESSAGE_ERROR, replaceAttr } from "~utils/constants/message-const";
import { COOKIES_NAME, SESSION_NAME } from "~utils/constants/attributes-const";
import { useLocation } from "@reach/router";

const { Content } = Layout;
const { Text } = Typography;

const Login = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email") ?? '';
  const [errors, setErrors] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [rendered, setRendered] = useState(true);
  const [form] = Form.useForm();
  const onFinish = async (values) => {
    setLoading(true);
    const params = {
      email: values.email,
      password: values.password,
    };
    const response = await connectPost(API_CONST.API_LOGIN_USER, params);
    const err = response?.res.data.error;
    const data = response?.res.data.data;
    if (err.status) {
      if (err.message.includes("SMS送信の待ち時間は60秒です") || err.message.includes("SMSの試行回数が10回を超えました。")) {
        localStorage.removeItem("is_login");
        localStorage.setItem("is_login","true");
        await navigate(`/user/second-auth-sms`);
        return;
      }
      setErrors(err.message);
      setLoading(false);
      return;
    }
    setLoading(false);
    form.resetFields();
    setErrors("");
    const currentDate = new Date();
    if (data) {
      if (data.activation) {
        Cookies.set(COOKIES_NAME.LOGIN_MAIL_ADDRESS, data.mail_address);
        await navigate(`/user/verify-activation-code`);
        return;
      }

      if (data.access_token) {
        Cookies.set(COOKIES_NAME.LOGIN_ROLE_ID, data.user_info.role_id);
        // @ts-ignore
        Cookies.set(COOKIES_NAME.LOGIN_USER_NAME, data.user_info.user_name);
        const urlRedirect = sessionStorage.getItem(SESSION_NAME.USER_URL_REDIRECT);
        if (urlRedirect) {
          sessionStorage.removeItem(SESSION_NAME.USER_URL_REDIRECT);
          await navigate(urlRedirect)
          return;
        }
        // @ts-ignore
        Cookies.set(COOKIES_NAME.LOGIN_MAIL_ADDRESS, data.user_info.mail_address);
        await navigate(URL.USER_MYPAGE);
        return;
      }

      const expirationTime = new Date(
        currentDate.getTime() + 24 * 60 * 60 * 1000
      );
      Cookies.set(COOKIES_NAME.LOGIN_SECOND_AUTH_TOKEN, data.token, { expires: expirationTime });
      Cookies.set(COOKIES_NAME.PHONE_NUMBER, data.phone_number);
    }
    localStorage.removeItem("is_login");
    localStorage.setItem("is_login","true");
    await navigate(`/user/second-auth-sms`);
  };
  useEffect(() => {
    // clear cookies
    for(let cookieName in COOKIES_NAME) {
        Cookies.remove(COOKIES_NAME[cookieName])
    }

    // remove sesion storage
    sessionStorage.removeItem('user-register');
    sessionStorage.removeItem('corp_temp');
    sessionStorage.removeItem('isErpInfo');

    const delay = getTimeLoadDom();

    const timeoutId = setTimeout(() => {
      setRendered(false);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, []);
  return <>
    <Helmet>
      <title>ユーザログイン</title>
      <link rel="icon" type="image/x-icon" href="/web.d/images/favicon.ico"/>
    </Helmet>
    <div className={`${rendered ? 'display-none' : ''}`}>
      <Layout style={{backgroundColor: "#EAE9E9", height: "100vh"}}>
        <Content
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="modal-login"
            style={{borderRadius: "10px", backgroundColor: "#fff"}}
          >
            <div className="card-body mx-md-4">
              <div className="text-center">
                <img
                  src="/web.d/images/logo.png"
                  style={{width: "250px", margin: "10px 0"}}
                  alt="logo"
                />
              </div>
              <div className="login-content  mt-2 mb-5">
                <h1 className="text-center text-design">ログイン</h1>
                <Form
                  name="loginForm"
                  initialValues={{remember: true, email}}
                  onFinish={onFinish}
                  form={form}
                  validateTrigger="onBlur"
                >
                  <Form.Item
                    getValueFromEvent={(e) => {
                      return e.target.value.trim();
                    }}
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message: replaceAttr(MESSAGE_ERROR.E0004, {attr: "メールアドレス"})
                      },
                      {
                        required: true,
                        message: replaceAttr(MESSAGE_ERROR.E0002, {attr: "メールアドレス"})
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      onChange={() => setErrors("")}
                      placeholder="メールアドレス"
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: replaceAttr(MESSAGE_ERROR.E0002, {attr: "パスワード"})
                      },
                      {
                        pattern: /^.{8,}$/,
                        message: replaceAttr(MESSAGE_ERROR.E0005, {attr: "パスワード", num: "8"})
                      },

                    ]}
                  >
                    <Input.Password
                      onChange={() => setErrors("")}
                      size="large"
                      placeholder="パスワード"
                    />
                  </Form.Item>
                  {errors && (
                    <Text
                      style={{position: "relative", top: "-14px"}}
                      type="danger"
                    >
                      {errors}
                    </Text>
                  )}
                  <div className="text-center">
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      block
                      loading={loading}
                    >
                      ログイン
                    </Button>
                  </div>
                  <div className="link-user-register">
                    <a
                      style={{textDecoration: "none"}}
                      href={'/web.d'+URL.USER_RESET_PASSWORD}
                    >
                      パスワードをお忘れの方。
                    </a>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Content>
      </Layout>
      <Spin spinning={rendered || loading} fullscreen/>
    </div>
  </>
};

export default Login;
